import { useEffect, useState } from 'react'
import { useParams, useSearchParams, useNavigate } from 'react-router-dom'
import api from '../../api/client'

export default function Loja() {
  const { codigo } = useParams()
  const nav = useNavigate()
  const [params] = useSearchParams()
  const filtro = params.get('o')       // vitrine personalizada (ids)
  const saudacao = params.get('c')     // nome do cliente (opcional)
  const [loja, setLoja] = useState(null)
  const [estado, setEstado] = useState('carregando')
  const [cart, setCart] = useState({})
  const [dados, setDados] = useState({ nome: saudacao || '', email: '', whatsapp: '' })
  const [resultado, setResultado] = useState(null)

  useEffect(() => {
    const q = filtro ? `?o=${encodeURIComponent(filtro)}` : ''
    api.get(`/loja/${codigo}${q}`).then((r) => { setLoja(r.data); setEstado('ok') }).catch(() => setEstado('erro'))
  }, [codigo, filtro])

  const lista = loja?.ofertas || loja?.produtos || []
  function add(id) { setCart((c) => ({ ...c, [id]: (c[id] || 0) + 1 })) }
  function sub(id) { setCart((c) => ({ ...c, [id]: Math.max(0, (c[id] || 0) - 1) })) }
  const itens = lista.filter((p) => cart[p.id] > 0)
  const subtotal = itens.reduce((s, p) => s + p.preco * cart[p.id], 0)
  const frete = Number(loja?.config?.frete_padrao || 0)
  const impostos = +(subtotal * Number(loja?.config?.imposto_pct || 0) / 100).toFixed(2)
  const total = +(subtotal + frete + impostos).toFixed(2)

  async function finalizar() {
    const body = { nome: dados.nome, email: dados.email, whatsapp: dados.whatsapp,
      itens: itens.map((p) => ({ oferta_id: p.id, qtd: cart[p.id] })) }
    const { data } = await api.post(`/loja/${codigo}/pedido`, body)
    setResultado(data)
    if (data?.codigo) nav(`/pagamento/${data.codigo}`)   // checkout transparente (PIX/boleto/cartão)
  }

  if (estado === 'carregando') return <div className="p-10 text-center text-gray-400">Carregando loja...</div>
  if (estado === 'erro') return <div className="p-10 text-center text-red-600">Loja não encontrada.</div>

  return (
    <div className="min-h-screen bg-offwhite">
      <header className="bg-gradient-to-r from-graphite via-neutral-900 to-accent-700 text-white px-6 py-4">
        <div className="font-heading text-lg font-bold">Loja de {loja.licenciado.nome}</div>
        <div className="text-xs text-white/60">The Conect Energy · cód. {loja.licenciado.codigo}</div>
      </header>

      {saudacao && (
        <div className="max-w-4xl mx-auto px-6 pt-5">
          <div className="bg-gradient-to-r from-amber-400 via-orange-400 to-accent-500 text-white rounded-2xl px-5 py-3 font-medium shadow-sm">
            Olá, {saudacao}! Separei estas ofertas especialmente para você 👇
          </div>
        </div>
      )}

      <div className="max-w-4xl mx-auto p-6 grid md:grid-cols-3 gap-6">
        <div className="md:col-span-2 grid sm:grid-cols-2 gap-4">
          {lista.map((p) => (
            <div key={p.id} className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
              {p.imagem_url && <img src={p.imagem_url} alt="" className="h-28 w-full object-cover rounded-lg mb-2" />}
              <div className="flex items-center gap-2">
                <p className="font-medium text-gray-900 flex-1">{p.nome}</p>
                <span className="text-[10px] uppercase font-bold px-1.5 py-0.5 rounded-full bg-primary-100 text-primary-700">{p.tipo || 'item'}</span>
              </div>
              {p.descricao && <p className="text-xs text-gray-500 mt-0.5 line-clamp-2">{p.descricao}</p>}
              <p className="text-accent-600 font-semibold mt-1">R$ {Number(p.preco).toFixed(2)}{p.recorrente ? '/mês' : ''}</p>
              <div className="flex items-center gap-2 mt-2">
                <button onClick={() => sub(p.id)} className="w-7 h-7 rounded-lg bg-gray-100">-</button>
                <span>{cart[p.id] || 0}</span>
                <button onClick={() => add(p.id)} className="w-7 h-7 rounded-lg bg-accent-500 text-white">+</button>
              </div>
            </div>
          ))}
          {lista.length === 0 && <p className="text-gray-400">Sem itens disponíveis.</p>}
        </div>

        <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100 h-fit">
          <p className="font-heading text-lg font-bold mb-2">Resumo</p>
          {itens.map((p) => (
            <div key={p.id} className="flex justify-between text-sm py-1">
              <span>{cart[p.id]}× {p.nome}</span><span>R$ {(p.preco * cart[p.id]).toFixed(2)}</span>
            </div>
          ))}
          <div className="border-t border-gray-100 mt-2 pt-2 space-y-1 text-sm">
            <div className="flex justify-between text-gray-600"><span>Subtotal</span><span>R$ {subtotal.toFixed(2)}</span></div>
            <div className="flex justify-between text-gray-600"><span>Frete</span><span>{frete > 0 ? `R$ ${frete.toFixed(2)}` : 'Grátis'}</span></div>
            {impostos > 0 && <div className="flex justify-between text-gray-600"><span>Impostos</span><span>R$ {impostos.toFixed(2)}</span></div>}
            <div className="flex justify-between font-semibold text-gray-900 pt-1"><span>Total</span><span>R$ {total.toFixed(2)}</span></div>
          </div>

          {!resultado ? (
            <div className="mt-4 space-y-2">
              <input placeholder="Seu nome" value={dados.nome} onChange={(e) => setDados({ ...dados, nome: e.target.value })} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm" />
              <input placeholder="E-mail" value={dados.email} onChange={(e) => setDados({ ...dados, email: e.target.value })} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm" />
              <input placeholder="WhatsApp" value={dados.whatsapp} onChange={(e) => setDados({ ...dados, whatsapp: e.target.value })} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm" />
              <button onClick={finalizar} disabled={!itens.length || !dados.nome}
                className="w-full rounded-lg bg-gradient-to-r from-primary-500 to-accent-500 text-white py-2.5 font-semibold disabled:opacity-50">
                Finalizar compra
              </button>
            </div>
          ) : (
            <div className="mt-4 text-sm">
              <p className="text-emerald-600 font-medium">Pedido {resultado.codigo} criado!</p>
              <a href={resultado.link_pagamento} target="_blank" rel="noreferrer"
                className="block mt-2 rounded-lg bg-graphite text-white text-center py-2.5">Pagar agora</a>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
